import { ActivityIndicator, Text, View } from "react-native";

interface LoadingSpinnerProps {
	message?: string;
	size?: "small" | "large";
}

/**
 * Loading spinner component for route transitions and async operations
 */
export function LoadingSpinner({
	message = "Loading...",
	size = "large",
}: LoadingSpinnerProps) {
	return (
		<View
			style={{
				flex: 1,
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "#f9fafb",
			}}
		>
			<ActivityIndicator size={size} color="#3b82f6" />
			<Text
				style={{
					marginTop: 16,
					fontSize: 16,
					color: "#6b7280",
					textAlign: "center",
				}}
			>
				{message}
			</Text>
		</View>
	);
}

/**
 * Loading fallback for React Suspense boundaries
 */
export function RouteLoadingFallback() {
	return <LoadingSpinner message="Loading page..." />;
}
